import { api } from "../utils/api";
import type { Entitlements } from "@KassaroAB/shared/types/entitlements";
import type { MeteredUsageSummary } from "@KassaroAB/shared/types/paymentProviderUsage";
import type { StoreId } from "@KassaroAB/shared/types/ids";

export const getEntitlementsApi = async (
  storeId: StoreId,
  date?: string
): Promise<Entitlements> => {
  const query = date ? `?date=${date}` : "";
  return api.get(`stores/${storeId}/entitlements${query}`);
};

export const getMeteredUsageApi = async (
  storeId: StoreId,
  yearMonth?: string
): Promise<MeteredUsageSummary> => {
  const query = yearMonth ? `?yearMonth=${yearMonth}` : "";
  return api.get(`stores/${storeId}/entitlements/usage${query}`);
};
